/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Billing page components
import Invoice from "layouts/pages/account/invoices/components/Invoice";
import BaseLayout from "layouts/pages/account/components/BaseLayout";
import { serverBaseURL } from "common/settings";
import { loadStripe } from "@stripe/stripe-js";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";

const stripePromise = loadStripe("pk_test_KtVhdGkKsR83L222KaGaDrtT");

function Invoices() {
  const { getToken, getUser } = useKindeAuth();
  const user = getUser();
  const [userBills, setUserBills] = useState({
    results: [],
  });
  const navigate = useNavigate();
  async function getUserBill(userBillUrl) {
    console.log("get balance transactions");
    const accessToken = await getToken();
    const customer = await (
      await fetch(`${serverBaseURL}current_customer`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          email: user.email,
        }),
      })
    ).json();
    console.log(customer);
    /*
    const params = {
      customer_id: customer.id,
    };
    if (startingAfter) {
      params.starting_after = startingAfter;
    }
    if (endingBefore) {
      params.ending_before = endingBefore;
    }
    */
    const urlObj = new URL(userBillUrl);
    //url.search = new URLSearchParams(params).toString();
    console.log(urlObj);
    const userBills = await (
      await fetch(urlObj, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
    ).json();
    setUserBills(userBills);
    console.log(userBills);
  }
  useEffect(() => {
    const baseUrl = `${serverBaseURL}user_bill/`;
    getUserBill(baseUrl);
  }, []);
  return (
    <BaseLayout stickyNavbar>
      <MDBox mt={4}>
        <MDBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Card sx={{ height: "100%" }}>
                <MDBox
                  pt={2}
                  px={2}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <MDTypography variant="h6" fontWeight="medium">
                    Invoices
                  </MDTypography>
                  <MDBox display="flex" gap={1}>
                    {userBills.previous && (
                      <MDButton
                        variant="outlined"
                        color="info"
                        size="small"
                        onClick={() => getUserBill(userBills.previous)}
                      >
                        previous page
                      </MDButton>
                    )}
                    {userBills.next && (
                      <MDButton
                        variant="outlined"
                        color="info"
                        size="small"
                        onClick={() => getUserBill(userBills.next)}
                      >
                        next page
                      </MDButton>
                    )}
                  </MDBox>
                </MDBox>
                <MDBox p={2}>
                  <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
                    {userBills.results.map((result) => (
                      <Invoice
                        key={`${result.id}`}
                        date={`${result.year}-${result.month}`}
                        id=""
                        price={`${result.total_amount / 100}`}
                        userBillId={`${result.id}`}
                        onClick={() => {
                          navigate("/account/invoice-detail", { state: { id: result.id } });
                        }}
                      />
                    ))}
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </BaseLayout>
  );
}

export default Invoices;
